export function getSignedInUserInfoStyle(theme) {
    return {
        details: {
            textAlign: "right",
        },
        primaryText: {
            // Actual styling of the primaryText text content needs to be provided via getUserInfoPrimaryTextStyle.
            height: "16px",
        },
        root: {
            flexDirection: "row-reverse",
        },
        secondaryText: {
            a: {
                color: "#005FB7",
                textDecoration: "none",
            },
            overflowX: "clip",
            overflowY: "visible",
        },
        tertiaryText: {
            display: "block",
        },
    };
}
export function getVeriyAccountLinkStyle(theme) {
    return {
        details: {
            textAlign: "right",
        },
        primaryText: {
            // Verify account link will be the secondary text, so remove primary from layout to prevent any extra whitespace.
            display: "none",
        },
        root: {
            flexDirection: "row-reverse",
            // Height is 32px since we're using Persona size32. This produces too wide of a gap between Sign out and Verify account links.
            // So reduce the height to vertically align the Verify account link.
            height: "22px",
            maxHeight: "22px",
        },
        secondaryText: {
            a: {
                color: "#005FB7",
                textDecoration: "none",
            },
            overflowX: "clip",
            overflowY: "visible",
        },
    };
}
export function getVerifyAccountCoinStyle(theme) {
    return {
        style: {
            // Hide the Persona coin but keep it in the visual layout.
            visibility: "hidden",
        },
    };
}
export function getUserInfoPrimaryTextStyle(theme) {
    return {
        root: {
            color: theme.customSemanticColors.textSecondary,
        },
    };
}
export var UserPersonaBadgeType;
(function (UserPersonaBadgeType) {
    UserPersonaBadgeType[UserPersonaBadgeType["ReauthRequired"] = 0] = "ReauthRequired";
    UserPersonaBadgeType[UserPersonaBadgeType["SignedOut"] = 1] = "SignedOut";
})(UserPersonaBadgeType || (UserPersonaBadgeType = {}));
;
export function getPersonaBadgeIconStyle(theme, badgeType) {
    let badgeColor;
    let fontWeight;
    switch (badgeType) {
        case UserPersonaBadgeType.ReauthRequired:
            badgeColor = theme.customSemanticColors.systemCritical;
            fontWeight = "bold";
            break;
        case UserPersonaBadgeType.SignedOut:
            badgeColor = theme.customSemanticColors.badgeIconSignedOut;
            fontWeight = "normal";
            break;
        default:
    }
    return {
        root: {
            // Use background color for "Selected Text" in Settings app which matchs the Hightlight color according to
            // https://blogs.windows.com/msedgedev/2020/09/17/styling-for-windows-high-contrast-with-new-standards-for-forced-colors/
            "@media (-ms-high-contrast: active), (forced-colors: active)": {
                "-ms-high-contrast-adjust": "none",
                color: "Highlight",
                "forced-color-adjust": "none"
            },
            color: badgeColor,
            fontSize: "16px",
            fontWeight: fontWeight,
            position: "absolute",
            right: "-8px",
            top: "-5px"
        },
    };
}
export function getSignedOutUserInfoStyle(theme) {
    return {
        details: {
            textAlign: "right",
        },
        primaryText: {
            height: "21px",
        },
        root: {
            flexDirection: "row-reverse",
        },
        secondaryText: {
            a: {
                color: "#005FB7",
                textDecoration: "none",
            },
            overflowX: "clip",
            overflowY: "visible",
        },
        tertiaryText: {
            display: "block",
        },
    };
}
